import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const paper: SxProps<Theme> = (theme) => ({
  borderRadius: 3,
  p: theme.spacing(1),
  maxWidth: 440,
});

export const header: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  pb: 1,
});

export const iconWrap: SxProps<Theme> = (theme) => ({
  width: 44,
  height: 44,
  borderRadius: 1.75,
  bgcolor: alpha(theme.palette.error.main, 0.12),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export const title: SxProps<Theme> = {
  fontSize: "0.9375rem",
  fontWeight: 700,
};

export const content: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.25),
});

export const message: SxProps<Theme> = {
  fontSize: "0.8125rem",
  color: "text.primary",
  lineHeight: 1.9,
};

export const dataSafeText: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "text.secondary",
  lineHeight: 1.8,
};

export const actions: SxProps<Theme> = {
  px: 2,
  pb: 2,
  gap: 1,
};
